"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.object.to-string.js");
var _activationCode = require("@/api/activationCode");
var _qrcode = _interopRequireDefault(require("qrcode.vue"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment'
var _default = exports.default = {
  name: 'ActivationCode',
  components: {
    QrcodeVue: _qrcode.default
  },
  props: {
    parentId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    codeType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      codeImg: null,
      dialogVisible: false,
      codeDialogVisible: false,
      limitDialogVisible: false,
      loading: false,
      codeList: [],
      originalCodeList: [],
      errorMsg: '',
      errorStyle: '',
      disableGenButton: false,
      form: {
        numberOfCodes: 0,
        userLimit: 0
      },
      query: {
        page: 1,
        limit: 100,
        sort: 'status'
      }
    };
  },
  created: function created() {
    var _this = this;
    if (this.parentId !== 'copy') {
      var codetype = _lifehikesInitData.ActivationCodeType.find(function (p) {
        return p === _this.codeType;
      });
      console.info("codetype：" + codetype);
      console.info("parentId：" + this.parentId);
      this.$set(this.form, codetype, this.parentId);
      this.$set(this.query, codetype, this.parentId);
      this.getCode();
    }
  },
  methods: {
    openDialogBox: function openDialogBox() {
      // this.$refs.qrcode.open()
      this.dialogVisible = true;
      this.errorMsg = '';
      this.form.userLimit = 1;
      this.form.numberOfCodes = 1;
      this.disableGenButton = false;
    },
    genCode: function genCode() {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');

      // console.log('gencode-form', this.form)

      (0, _activationCode.generateCode)(token, this.form).then(function (response) {
        _this2.codeList = _this2.codeList.concat(response.data);
        switch (_this2.codeType) {
          case 'hike':
            (0, _ga.writeGaEvent)(_this2, 'Hike', "".concat(_lifehikesInitData.userEvent.hike.generateCode), oEmail, "Hike Id: ".concat(_this2.parentId));
            break;
          case 'training':
            (0, _ga.writeGaEvent)(_this2, 'Event', "".concat(_lifehikesInitData.userEvent.training.generateCode), oEmail, "Event Id: ".concat(_this2.parentId));
            break;
          case 'loop':
            (0, _ga.writeGaEvent)(_this2, "Loop", "".concat(_lifehikesInitData.userEvent.loop.generateCode), oEmail, "Loop Id: ".concat(_this2.parentId));
            break;
        }
        _this2.errorMsg = "Error : Fail to generate the code";
        _this2.errorStyle = 'color:#67C23A';
        _this2.disableGenButton = true;
        _this2.getCode();
        _this2.dialogVisible = false;
        var msg = "QR code is generated successfully";
        (0, _log.displayPopupMessage)(msg, 'success');
      }).catch(function (error) {
        (0, _log.showDebugLog)('GenerateCode-API-error', error);
        _this2.errorMsg = "Error : Fail to generate the code";
        _this2.errorStyle = 'color:#F56C6C';
        (0, _log.displayPopupMessage)(_this2.errorMsg, 'error');
      });
    },
    getCode: function getCode() {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _activationCode.getCodeList)(token, this.query).then(function (response) {
        _this3.loading = false;
        (0, _log.showDebugLog)(_this3.codeType + '-Code-Search-response', response);
        _this3.codeList = _lodash.default.cloneDeep(response.data.rows);
        _this3.originalCodeList = _lodash.default.cloneDeep(response.data.rows);
      }).catch(function (error) {
        (0, _log.showDebugLog)(_this3.codeType + '-code-search-api-error', error);
        _this3.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    updateLimit: function updateLimit(c, index) {
      var _this4 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      var body = {
        userLimit: c.userLimit
      };
      if (this.originalCodeList[index].userLimit >= c.userLimit) {
        (0, _log.displayPopupMessage)('Reuse value cannot be smaller than before', 'error');
        return;
      }
      (0, _activationCode.updateCode)(token, c.id, body).then(function (response) {
        switch (_this4.codeType) {
          case 'hike':
            (0, _ga.writeGaEvent)(_this4, 'Hike', "".concat(_lifehikesInitData.userEvent.hike.updateCode), oEmail, "Hike Id: ".concat(_this4.parentId));
            break;
          case 'training':
            (0, _ga.writeGaEvent)(_this4, 'Event', "".concat(_lifehikesInitData.userEvent.training.updateCode), oEmail, "Event Id: ".concat(_this4.parentId));
            break;
          case 'loop':
            (0, _ga.writeGaEvent)(_this4, "Loop", "".concat(_lifehikesInitData.userEvent.loop.updateCode), oEmail, "Loop Id: ".concat(_this4.parentId));
            break;
        }
        _this4.getCode();
        (0, _log.displayPopupMessage)('QR Code is updated', 'success');
      }).catch(function (error) {
        (0, _log.showDebugLog)(_this4.codeType + '-code-updatelimit-api-error', error);
        (0, _log.displayPopupMessage)('Fail to update QR code', 'error');
      });
    },
    showQRCodePath: function showQRCodePath(code) {
      return _lifehikesInitData.qrPrefix + code;
    },
    printCode: function printCode(idx) {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var el, options;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              el = _this5.$refs.displayCode;
              _this5.codeDialogVisible = true;
              options = {
                type: 'dataURL'
              };
              _context.n = 1;
              return _this5.$html2canvas(el[idx], options);
            case 1:
              _this5.codeImg = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};